// This is the entry point for the application (insofar as the
// React/Webpack pipeline is concerned). There are other scripts in the
// default Rails pipeline in /app/assets/javascripts (legacy code as of the
// introduction of React) that are loaded in before this application. This file
// bootstraps React, exposes NPM modules to the window object for legacy code,
// and runs other bootstrap scripts.

// Support component names relative to the ../components directory.
// React components are added to Rails views like so:
//  <%= react_component 'layout/foo/bar' %>
// which loads the component at /app/javascript/components/layout/foo/bar.jsx
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext);
